import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material.module';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-success-screen',
  imports: [CommonModule, MaterialModule, TranslatePipe],
  template: `
    <div class="success-container">
      <mat-card class="success-card">
        <mat-card-content>
          <div class="success-content">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <h2>{{ 'success.title' | translate }}</h2>
            <p>{{ 'success.message' | translate }}</p>
            
            <div class="action-section">
              <button mat-raised-button 
                      color="primary" 
                      (click)="onNewReport()"
                      class="new-report-btn">
                <mat-icon>add</mat-icon>
                {{ 'success.newReport' | translate }}
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  `,
  styles: [`
    .success-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 60vh;
      padding: 20px;
    }

    .success-card {
      max-width: 500px;
      width: 100%;
      text-align: center;
    }

    .success-content {
      padding: 40px 20px;
    }

    .success-icon {
      font-size: 80px;
      width: 80px;
      height: 80px;
      color: #4caf50;
      margin-bottom: 20px;
    }

    h2 {
      color: #2e7d32;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 500;
    }

    p {
      color: #666;
      margin-bottom: 32px;
      font-size: 16px;
      line-height: 1.5;
    }

    .action-section {
      display: flex;
      justify-content: center;
    }

    .new-report-btn {
      padding: 12px 32px;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    @media (max-width: 768px) {
      .success-content {
        padding: 20px 10px;
      }
      
      .success-icon {
        font-size: 60px;
        width: 60px;
        height: 60px;
      }
      
      h2 {
        font-size: 20px;
      }
      
      .new-report-btn {
        width: 100%;
        padding: 16px 24px;
      }
    }
  `]
})
export class SuccessScreenComponent {
  @Output() newReport = new EventEmitter<void>();

  onNewReport(): void {
    this.newReport.emit();
  }
}